<div class="handles">
    <ng-content></ng-content>
    <app-handle (click)="close()">
        <i class="fa fa-times"></i>
    </app-handle>
</div>

<app-panel class="panel">
    <i icon class="fas fa-pen-alt"></i>
    <div title>Pen</div>
    <app-color-selector (changed)="onColorChange($event)" [value]="color$ | async"></app-color-selector>
    <app-control-diameter (changed)="onDiameterChange($event)" [value]="size$ | async" [cssVariableScale]="3"></app-control-diameter>
</app-panel>
